export enum LicenseState {
  NOT_OWNED = 'not_owned',
  FUTURE = 'future',
  ACTIVE = 'active',
  EXPIRED = 'expired',
}
